import { LogType } from '../shared/types';

export const getLogColor = (type: LogType): string =>
  ({ warning: '#ffa600', error: '#f5222d', debug: '#144a5c', info: 'rgba(0, 0, 0, 0.26)' }[type]);
